import {
	indexOf,
	get
} from 'lodash'
import {
	graphql
} from 'gatsby'
import renderHTML 		from 'react-render-html'
import moment 			from 'moment'

export const formatAcfImageForARYImage = (image, size = 'full') => {
	return image && image.sizes[size] ? {
		src: image.sizes[size],
		width: image.sizes[size + '_width'],
		height: image.sizes[size + '_height']
	} : null
}

export const formatWpImageForARYImage = (image) => {
	return image && image.source_url ? {
		src: image.source_url,
		width: image.media_details.width,
		height: image.media_details.height
	} : null
}

export const formatImageForARYImage = (image, size = null) => {
	if(!image){ return null }
	
	const _gatsbyImage = get(image, 'localFile.childImageSharp')
	if(_gatsbyImage){
		if(_gatsbyImage.fixed){
			return {
				..._gatsbyImage.fixed,
				gatsbyImage: true,
				gatsbyImageType: 'fixed'
			}
		} else if(_gatsbyImage.fluid){
			return {
				..._gatsbyImage.fluid,
				gatsbyImage: true,
				gatsbyImageType: 'fluid'
			}
		}
	}

	if(image.source_url){
		return {
			src: image.source_url,
			width: image.media_details.width,
			height: image.media_details.height
		}
	}

	const _size = size ? size : 'full'
	const _acfImage = get(image, `sizes.${ size }`)
	if(_acfImage){
		return {
			src: _acfImage,
			width: image.sizes[size + '_width'],
			height: image.sizes[size + '_height']
		}
	}

	return null
}

export const locationHasChanged = (prevLocation, location) => {
	return prevLocation.key !== location.key
}

export const colourIsDark = (colour) => {
	const darkColours = ['blue', 'coralAlt', 'turquoise']
	return indexOf(darkColours, colour) >= 0
}

export const formatImageArray = (images = [], key = null, type = 'wp') => {
	let arr = []
	
	for(let i = 0; i < images.length; i++){
		const _image = get(images[i], key)
		let _imageObj = false
		if(_image){
			if(type === 'wp'){
				_imageObj = formatWpImageForARYImage(_image)
			} else {
				_imageObj = formatAcfImageForARYImage(_image)
			}
		}

		if(_imageObj){
			arr.push(_imageObj)
		}
	}

	return arr
}

export const wrapIndexShift = (index, shift, length) => {
	let _index = index + shift
	if(_index >= length){
		_index = 0
	} else if(_index < 0){
		_index = length - 1
	}
	return _index
}

export const mapImagesToBubbleStack = (arr) => {
	const ps = [
		{
			w: 0.71,
			x: 0.63,
			y: 0.45
		},
		{
			w: 0.27,
			x: 0.30,
			y: 0.85
		},
		{
			w: 0.17,
			x: 0.14,
			y: 0.43
		},
		{
			w: 0.16,
			x: 0.07,
			y: 0.68
		},
		{
			w: 0.23,
			x: 0.19,
			y: 0.14
		}
	]
	let images = []
	if(arr && arr.length > 0){
		for(let i = 0; i < arr.length; i++){
			const _arr = arr[i]
			if(_arr.image){
				images.push({
					image: formatImageForARYImage(_arr.image),
					...ps[i]
				})
			}
			if(images.length >= ps.length){
				break
			}
		}
	}
	return images
}